import { LocationNumbersService } from '../../../services'

const deleteNumberFromPool = async function ({ commit, dispatch, state }, payload) {
  const { locationId, poolId, phoneNumber, numberId } = payload

  commit('startLoading')
  try {
    const result = await LocationNumbersService.deleteNumberFromPool({
      locationId,
      poolId,
      phoneNumber,
      numberId
    })
    await dispatch('fetchNumberPool', {
      numberPools: state.numberPoolIDs,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: state.table?.searchText ?? '',
      },
    })
    commit('stopLoading')
    return result
  } catch (error) {
    commit('stopLoading')
    throw error
  }
}

export default deleteNumberFromPool 